const env = (key, defaultValue = null) => process.env[key] || defaultValue;
const isEnabled = key => env(key) && env(key) === 'true';

const cacheTTL = parseFloat(env('VUE_APP_CACHE_TTL_IN_HOURS', 1)) * 60 * 60 * 1000;

const config = {
    cacheTTL,
    baseApiUrl: env('VUE_APP_BASE_API_URL', 'http://127.0.0.1:3001/'),
    apiUrl: env('VUE_APP_API_URL', 'http://127.0.0.1:3001/api'),
    env: env('NODE_ENV'),
    environment: env('VUE_APP_ENVIRONMENT'),
    isApiMocked: isEnabled('VUE_APP_IS_API_MOCKED'),
    logRocketId: env('VUE_APP_LOG_ROCKET_ID'),
    mixpanelToken: env('VUE_APP_MIXPANEL_TOKEN'),
    publicPath: env('VUE_APP_PUBLIC_PATH', '/'),
    projectName: 'affogata',
    segmentWriteKey: env('VUE_APP_SEGMENT_WRITE_KEY'),
    sentry: {
        environment: env('VUE_APP_SENTRY_ENVIRONMENT'),
        dsn: env('VUE_APP_SENTRY_DSN'),
        enabled: !!env('VUE_APP_SENTRY_DSN'),
        release: env('VUE_APP_SENTRY_RELEASE'),
        logErrors: isEnabled('VUE_APP_SENTRY_LOG_ERRORS'),
        timeout: env('VUE_APP_SENTRY_TIMEOUT'),
        tracesSampleRate: parseFloat(env('VUE_APP_TRACES_SAMPLE_RATE'))
    },
    tenorApiKey: env('VUE_APP_TENOR_API_KEY'),
    PUSHER_ID: env('VUE_APP_PUSHER_ID'),
    url: env('VUE_APP_URL', 'http://127.0.0.1:8080')
};

module.exports = config;
